module.exports = ".clientList .list-group-item:nth-child(2n+1) {\n    background-color: rgba(0, 0, 0, 0.05);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/client-list/client-list.component.css
// module id = ./src/app/admin/client-list/client-list.component.css
// module chunks = main